import BaseTypedController from "ips/ac/base/controller/BaseTypedController";
import Controller from "sap/ui/core/mvc/Controller";
import XMLView from "sap/ui/core/mvc/XMLView";
import Table from "sap/m/Table";
import ColumnListItem from "sap/m/ColumnListItem";
import Sorter from "sap/ui/model/Sorter";
import JSONModel from "sap/ui/model/json/JSONModel";
import Util from "ips/ac/util/Util";
import User from "ips/ac/util/classes/user/User";
import HttpUtil from "ips/ac/util/HttpUtil";
import Response from "ips/ac/model/types/Response";
import formatter from "ips/ac/model/formatter";
import { ListItemBase$PressEvent } from "sap/m/ListItemBase";

interface RouteAwareController extends Controller {
  _sRouteName?: string;
}

interface PartnerUserDto {
  salutation?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  isActive?: boolean;
  lastAccess?: number;
}

/**
 * ClientUsers Controller
 *
 * @namespace ips.ac
 * @public
 */
export default class ClientUsersController extends BaseTypedController {

  public formatter = formatter;
  private itemTemplate: ColumnListItem;

  public onInit() {
    const table = this.getView().byId("ClientUsers") as Table;
    this.itemTemplate = table.getItems()[0].clone() as ColumnListItem;
    table.destroyItems();
  }

  public bindTable() {
    const table = this.getView().byId("ClientUsers") as Table;
    const clientGuid = this.getView().getBindingContext().getProperty("Guid");
    const sorter = new Sorter("UserFullname");

    table.bindItems({
      path: "clientUsers>/",
      template: this.itemTemplate,
      templateShareable: true,
      sorter: sorter,
    });

    this.loadUsers(clientGuid);
  }

  private async loadUsers(clientGuid: string) {
    const url = `${Util.getPrivateApi()}/client/partner/${clientGuid}/users`;
    const response: Response<PartnerUserDto[]> = await HttpUtil.get(url);
    const users = response.content ?? [];

    this.getView().setModel(new JSONModel(users), "clientUsers");
    this.getModel<JSONModel>("ui").setProperty("/countClientUsers", users.length);
  }

  public onAddUser() {
    const parentView = this.findParentControl("sap.ui.core.mvc.XMLView") as XMLView;
    const clientGuid = this.getView().getBindingContext().getProperty("Guid");

    const config = {
      mode: "create",
      entityDefaults: {
        sClientGuid: clientGuid,
        sCreatedByUserGuid: User.getInstance().getGuid(),
      },
      fromTarget: (parentView.getController() as RouteAwareController)._sRouteName,
    };
    this.setRouteDisplayData("employeecreate", config);
    this.navTo("employeecreate", config);
  }
}
